import React from 'react';

type Variant = 'primary' | 'success' | 'info' | 'outline' | 'ghost' | 'info-outline';
type Size = 'xs' | 'sm' | 'md' | 'lg';

const VARIANT: Record<Variant, string> = {
  primary:        'bg-orange-500 text-white hover:bg-orange-600 active:scale-95 disabled:opacity-50',
  success:        'bg-green-500 text-white hover:bg-green-600',
  info:           'bg-blue-500 text-white hover:bg-blue-600',
  outline:        'border border-orange-200 text-orange-500 hover:bg-orange-50',
  ghost:          'text-gray-500 hover:text-gray-700 hover:bg-gray-100',
  'info-outline': 'border border-blue-200 text-blue-600 hover:bg-blue-50',
};

const SIZE: Record<Size, string> = {
  lg: 'py-4 px-6 text-lg rounded-2xl font-bold shadow-lg',
  md: 'py-3 px-5 text-sm rounded-xl font-bold',
  sm: 'py-2.5 px-4 text-sm rounded-xl font-medium',
  xs: 'py-1.5 px-3 text-xs rounded-lg font-medium',
};

interface ButtonProps {
  variant?: Variant;
  size?: Size;
  fullWidth?: boolean;
  className?: string;
  children?: React.ReactNode;
  href?: string;
  target?: string;
  rel?: string;
  onClick?: React.MouseEventHandler;
  disabled?: boolean;
  type?: 'button' | 'submit' | 'reset';
}

const Button: React.FC<ButtonProps> = ({
  variant = 'primary',
  size = 'md',
  fullWidth = false,
  className = '',
  children,
  href,
  target,
  rel,
  ...rest
}) => {
  const cls = [
    'inline-flex items-center justify-center gap-1.5 transition-all',
    VARIANT[variant],
    SIZE[size],
    fullWidth ? 'w-full' : '',
    className,
  ].filter(Boolean).join(' ');

  if (href) {
    return (
      <a href={href} target={target} rel={rel} className={cls}>
        {children}
      </a>
    );
  }

  return (
    <button className={cls} {...rest}>
      {children}
    </button>
  );
};

export default Button;
